<template>
  <div class="newprogram">
    <van-cell-group>
      <van-field
          v-model="programName"
          label="节目名称"
          placeholder="请输入节目名称"
          required
      />
      <van-field
          v-model="programgroupName"
          label="节目分组"
          placeholder="请选择节目分组"
          @click="showPicker = true" readonly
          required
      />
      <van-field
          label="文本"
          placeholder="在失焦时执行格式化"
      >
        <span slot="label">显示类型</span>
        <van-radio-group slot="input" v-model="resolutionType" direction="horizontal">
          <van-radio name="2">比例</van-radio>
          <van-radio name="1">分辨率</van-radio>
        </van-radio-group>

      </van-field>
      <van-field
          label="文本"
          v-if="resolutionType === '2'"
      >
        <span slot="label">屏幕方向</span>
        <van-radio-group slot="input" v-model="fixedScreen" direction="horizontal">
          <van-radio name="1">横屏</van-radio>
          <van-radio name="2">竖屏</van-radio>
        </van-radio-group>

      </van-field>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="groupingList.map(res => {
               return res.name
             })"
            title="节目列表"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        ></van-picker>
      </van-popup>

      <van-field
          v-if="resolutionType === '1'"
          v-model="resolution"
          label="分辨率"
          placeholder="请选择分辨率"
          @click="showresolution = true" readonly
          required
      />
    </van-cell-group>
    <van-popup v-model="showresolution" position="bottom">
      <van-picker
          show-toolbar
          :columns="resolutions.map(res => {
               return (res.ruLPixel + '*' + res.ruWPixel)
             })"
          title="分辨率列表"
          @cancel="showresolution = false"
          @confirm="getresolution"
      />
    </van-popup>
    <div style="height: 20px;line-height: 20px;text-align: right;margin-top: 10px">
      <router-link to="/addresolution">新增分辨率</router-link>
    </div>
    <div style="height: 30px"></div>
    <van-button block type="info" size="small" @click="onprogramShow">添加</van-button>
  </div>
</template>

<script>
import qs from 'qs'
import {Toast} from 'vant'
import $ from 'jquery'

export default {
  name: 'newprogram',
  data() {
    return {
      programNameIndex: 0,  //节目名称
      programgroupName: '', //节目分组名称
      programName: `pro-${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes() + 1}${new Date().getSeconds()}`,  //节目名称
      showPicker: false,
      groupingList: [],
      showresolution: false,
      resolutions: [],
      resolution: '',
      resolutionIndex: 0,
      resolutionType: "2",
      fixedScreen: "1",

    }
  },
  mounted() {
    this.$nextTick(() => {
      var winHeight = $(window).height()
      $(window).resize(function () {
        var thisWidth = $(this).height()
        if (winHeight > thisWidth) {
          $('.nut-tabbar').hide()
        } else {
          $('.nut-tabbar').show()
        }
      })
    })

    this.createprogram()
  },
  methods: {
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },

    createprogram() {
      this.$ajax.post('/etv/selectProgramCategoryAll.json').then(res => {
        if (res.data.code === 0) {
          this.groupingList = res.data.data
          this.programgroupName = res.data.data[0].name
        }
      })
      this.$ajax.post('/etv/selectAllResolution.json').then(res => {
        if (res.data.code === 0) {
          this.resolutions = res.data.data
          this.resolution = res.data.data[0].ruLPixel + '*' + res.data.data[0].ruWPixel
        }
      })
    },
    onprogramShow() {

      if (this.programName === '') {
        Toast('请输入节目名称')
        return
      }

      this.$ajax.post('/etv/selectProgramMouldNameExist.json', qs.stringify({
        name: this.programName,
        pcId: this.groupingList[this.programNameIndex].id,
      })).then(res => {
        if (this.resolutionType === '2') {
          if (this.fixedScreen === '1') {
            this.resolution = '1920*1080'
          } else if (this.fixedScreen === '2') {
            this.resolution = '1080*1920'
          }
        }
        if (res.data.code === 0) {
          this.$ajax({
            url: '/etv/insertProgramMouldInfo.json',
            method: 'post',
            data: {
              pcId: this.groupingList[this.programNameIndex].id,
              name: this.programName,
              type: '1',
              resolution: this.resolution,
              platform: 'phone',
              resolutionType: this.resolutionType,
              fixedScreen: this.fixedScreen
            },
          }).then(res => {
            if (res.data.code === 0) {
              this.$router.push({
                path: '/createProrram',
                query: {
                  id: res.data.data.pmId,
                },
              })
            } else {
              Toast(res.data.msg)
            }
          })
        } else {
          Toast(res.data.msg)
        }
      })
    },
    getresolution(value) {
      this.showresolution = false
      this.resolution = value
    },
  },
}
</script>

<style scoped lang="scss">
.newprogram {
  padding: 10px;
  box-sizing: border-box;

  .nut-content {
    display: flex;

    .nut-label {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 80px;
      margin-right: 10px;
    }

    .nut-input {
      width: calc(100% - 30px);
      height: 40px;
      border: 1px solid #DDDFE6;
      border-radius: 4px;
      padding-left: 10px;
    }
  }

  a {
    color: #999999;
  }

}
</style>
